<script setup>
    import { onMounted, ref, computed } from 'vue';
    import useTermChangeList from '@/composables/useTerms';

    const { loading, readChangeList, showTermChangeModal, termsChangelist, onDecline, onAccept } = useTermChangeList();

    onMounted(() => {
        setTimeout(readChangeList, 1000);

    });

    const isRead = ref(false);

    const clientTerms = computed(() => {
        if (!termsChangelist.value) return [];
        return termsChangelist.value          
            .filter((obj) => obj && obj.Type === 0);
    });
    const subcontractorTerms = computed(() => {
        if (!termsChangelist.value) return [];
        return termsChangelist.value          
            .filter((obj) => obj && obj.Type === 1);
    })
    
</script>

<template>

    <n-modal v-model:show="showTermChangeModal" :mask-closable="false">
        <n-card class="max-w-4xl"
                :bordered="false"
                role="dialog"
                aria-modal="true">
            <h2 class="text-xl font-bold text-center my-2">NOTICE: Contract Term/s Have Changed </h2>
            <n-scrollbar class="max-h-[600px] shadow-sm p-3 border ">
                <div v-if="clientTerms.length > 0" class="text-base mb-6 bold text-center">                    
                    The Following Default Client Term/s Has Now Been Changed 
                </div>
                <div v-for="obj in clientTerms" :key="obj" class="text-base mb-6">
                    <div v-if="obj.IsNew" >
                        <div class="bold f12" style="color: green;">New Term {{obj.Number}} of the Client Agreement has now been Added:</div>
                        <div class="justify-between bold f12" v-html="obj.Text"></div>
                    </div>
                    <div v-else-if="obj.IsDeleted">
                        <div class="bold f12" style="color: red;">Term {{obj.Number}} of the Client Agreement has now been Deleted:</div>
                        <div class="justify-between bold f12" v-html="obj.Text"></div>
                    </div>
                    <div v-else>
                        <div class="bold f12">Term {{obj.Number}} of the Client Agreement has now been changed From:</div>
                        <div class="justify-between f12" v-html="obj.Original?.Text"></div>
                        <div class="bold f12">To:</div>
                        <div class="justify-between f12" v-html="obj.Text"></div>
                    </div>
                    
                </div>

                <div v-if="subcontractorTerms.length > 0" class="text-base mb-6 bold text-center">
                    The Following Default Sub-Contractor Term/s Has Now Been Changed 
                </div>
                <div v-for="obj in subcontractorTerms" :key="obj" class="text-base mb-6">
                    <div v-if="obj.IsNew" >
                        <div class="bold f12" style="color: green;">New Term {{obj.Number}} of the Sub-Contractor Agreement has now been Added:</div>
                        <div class="justify-between bold f12" v-html="obj.Text"></div>
                    </div>
                    <div v-else-if="obj.IsDeleted">
                        <div class="bold f12" style="color: red;">Term {{obj.Number}} of the Sub-Contractor Agreement has now been Deleted:</div>
                        <div class="justify-between bold f12" v-html="obj.Text"></div>
                    </div>
                    <div v-else>
                        <div class="bold f12">Term {{obj.Number}} of the Sub-Contractor Agreement has now been changed From:</div>
                        <div class="justify-between f12" v-html="obj.Original?.Text"></div>
                        <div class="bold f12">To:</div>
                        <div class="justify-between f12" v-html="obj.Text"></div>
                    </div>
                   
                </div>
            </n-scrollbar>
            <template #footer>
               
                <div class="flex justify-center mt-4">
                    <n-button class="!w-[110px] mr-6" block strong @click="onDecline">Decline</n-button>
                    <n-button class="!w-[110px]" type="primary" block strong @click="onAccept" >Understood</n-button>
                </div>
            </template>
        </n-card>
    </n-modal>
</template>
<style scoped>
    .f12{ font-size: 12px;}
</style>